import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-support-button',
  templateUrl: './support-button.component.html',
  styleUrls: ['./support-button.component.scss'],
})
export class SupportButtonComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
